// Google Fonts utility
export const loadGoogleFont = (fontFamily: string): void => {
  // Clean font name for URL (replace spaces with +)
  const fontUrl = fontFamily.replace(/\s+/g, "+");

  // Check if font is already loaded
  const existingLink = document.querySelector(`link[href*="${fontUrl}"]`);
  if (existingLink) return;

  // Create and append font link
  const link = document.createElement("link");
  link.href = `https://fonts.googleapis.com/css2?family=${fontUrl}:wght@300;400;500;600;700&display=swap`;
  link.rel = "stylesheet";
  document.head.appendChild(link);
};
